// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_kzL","cls2":"FilterPanel-cls2_cu2 FilterPanel-cls1_kzL"};